import { http, tryHttp } from '@pequity/shared/axios/http';
import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToApprovalsIfNoSettingsAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.approvals.settings) {
    return true;
  } else {
    return { name: 'approvals' };
  }
};

export const redirectToApprovalsIfNoExportAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.approvals.export) {
    return true;
  } else {
    return { name: 'approvals' };
  }
};

export const redirectToApprovalsIfNotDebugAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.approvals.debug) {
    return true;
  } else {
    return { name: 'approvals' };
  }
};

export const redirectToHomeIfNoApprovalsAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  // Check if user has any approvals access (either add or settings access) or navigation access
  if (
    authStore.appAccess.approvals.add ||
    authStore.appAccess.approvals.settings ||
    authStore.appAccess.nav.approvals
  ) {
    return true;
  } else {
    return { name: 'home' };
  }
};

export const redirectToApprovalsIndexIfNotValidId: NavigationGuard = async (to) => {
  const id = Number(to.params.id);

  if (isNaN(id) || id <= 0) {
    return { name: 'approvals' };
  } else {
    return true;
  }
};

export const redirectToApprovalsIfInvalidApplicationId: NavigationGuard = async (to) => {
  const applicationId = Number(to.params.applicationId);

  if (isNaN(applicationId) || applicationId <= 0) {
    return { name: 'approvals' };
  } else {
    return true;
  }
};

export const redirectIfWritebackField: NavigationGuard = async (to) => {
  const fieldId = Number(to.params.id);

  // If invalid ID, let the other guard handle it
  if (isNaN(fieldId) || fieldId <= 0) {
    return true;
  }

  // Check if this field is currently used as a writeback field
  const { data, error } = await tryHttp(
    http.get<{ field_id: number | null }>('ats-integration/settings/current-writeback-field')
  );

  if (error) {
    // If API call fails, allow navigation to continue (fail open)
    return true;
  }

  const currentWritebackFieldId = data.field_id;

  if (currentWritebackFieldId === fieldId) {
    // Redirect to custom fields page with error message in query params
    return {
      name: 'custom-fields',
      query: {
        error:
          'This field is being used in ATS settings for status writebacks and cannot be edited. Please remove it from ATS settings first.',
      },
    };
  } else {
    return true;
  }
};
